export default "__VITE_ASSET__CqkzPzCJ__"